/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ResolveRefundByAttemptResponseStatusEnum = {
    aborted: 'aborted',
    completed: 'completed',
    failed: 'failed',
    notFound: 'not_found',
    pending: 'pending'
};
/**
 * Check if a given object implements the ResolveRefundByAttemptResponse interface.
 */
export function instanceOfResolveRefundByAttemptResponse(value) {
    if (!('already' in value) || value['already'] === undefined)
        return false;
    if (!('refunded' in value) || value['refunded'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function ResolveRefundByAttemptResponseFromJSON(json) {
    return ResolveRefundByAttemptResponseFromJSONTyped(json, false);
}
export function ResolveRefundByAttemptResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'already': json['already'],
        'refunded': json['refunded'],
        'status': json['status'],
    };
}
export function ResolveRefundByAttemptResponseToJSON(json) {
    return ResolveRefundByAttemptResponseToJSONTyped(json, false);
}
export function ResolveRefundByAttemptResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'already': value['already'],
        'refunded': value['refunded'],
        'status': value['status'],
    };
}
